import { render, staticRenderFns } from "./UpdatePhones.vue?vue&type=template&id=92dbb958"
import script from "./UpdatePhones.vue?vue&type=script&lang=ts"
export * from "./UpdatePhones.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports